import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  Container,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  useMediaQuery,
  Divider,
  Button,
  Grid,
  Autocomplete,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  CircularProgress,
} from "@mui/material";
import {
  fetchItemsByOrgId,
  fetchSoldItemById,
  fetchItemByBillId,
  getAllBillByOrgId,
  fetchSoldItemByBillId,

} from "../services/api";
import { useUser } from "../context/UserContext";
import SearchIcon from "@mui/icons-material/Search";
import InputAdornment from "@mui/material/InputAdornment";
import { useTheme } from "@mui/material/styles";
import jsPDF from "jspdf";
import "jspdf-autotable";
import DownloadForOfflineOutlinedIcon from '@mui/icons-material/DownloadForOfflineOutlined';
import GetAppRoundedIcon from '@mui/icons-material/GetAppRounded';
import FastRewindRoundedIcon from '@mui/icons-material/FastRewindRounded';
import SpinnerLoading from "../utility/LoadingIndicator";

const Reports = () => {
  const { user } = useUser();
  const [searchTerm, setSearchTerm] = useState("");
  const [searchTermAggrigate, setSearchTermAggrigate] = useState("");
  const [items, setItems] = useState([]);
  const [itemsByUser, setItemsByUser] = useState([]);
  const [soldItems, setSoldItems] = useState([]);
  const [aggregateSoldStock, setAggregateSoldStock] = useState([]);
  const [bills, setBills] = useState([]);
  const [inventoryData, setInventoryData] = useState([]);
  const [stockInventoryData, setStockInventoryData] = useState([]);
  const [totalStockQuantitiesOfItem, setTotalStockQuanititiesOfItem] = useState([]);
  const [billId, setBillId] = useState("");
  const [selectedBill, setSelectedBill] = useState({});
  const [searchQuery, setSearchQuery] = useState("");
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const isLargeDevice = useMediaQuery(theme.breakpoints.up("lg")); // For large devices
  const isExtraLargeDevice = useMediaQuery(theme.breakpoints.up("xl"));
  const [loading, setLoading] = useState(true);


  const goAgrigateData = () => {
    setBillId("");
    fetchSoldItemsByUser();

  };

  // fetch all bills by orgId  
  const fetchBills = async (orgId) => {
    if (!user || !user.orgId) return;

    try {
      const response = await getAllBillByOrgId(orgId);
      if (
        response &&
        response.status === 200 &&
        Array.isArray(response.data.data)
      ) {
        setBills(response.data.data);
        console.log(response.data.data);
      } else {
        setBills([]);
      }
    } catch (error) {
      console.error("Failed to fetch bills:", error);
      setBills([]);
    }
  };

  // fetch all items by orgId 
  const fetchItemsByUser = async () => {
    if (!user || !user.orgId) return;
    try {
      const response = await fetchItemsByOrgId(user.orgId);
      if (response && response.status === 200) {
        setItemsByUser(response.data.data);
        console.log("fetch items by orgId", response.data.data);
      } else {
        setItemsByUser([]);
      }
    } catch (error) {
      console.error("Failed to fetch items:", error);
      setItemsByUser([]);
    }
  };

  //fetch items by selected bill
  const fetchItemsByBillId = async (billId) => {
    if (!user || !user.orgId) return;
    console.log(selectedBill);
    try {
      const response = await fetchItemByBillId(billId);
      if (response && response.status === 200) {
        setItems(response.data.data);
        console.log(response.data.data);
      } else {
        setItems([]);
      }
    } catch (error) {
      console.error("Failed to fetch items:", error);
      setItems([]);
    }
  };

  // fetch solditems by select bill
  const fetchSoldItemsByBill = async (billId) => {
    if (!user || !user.orgId) return;

    try {
      const response = await fetchSoldItemByBillId(billId); // Fetch sold items using orgId
      if (
        response &&
        response.status === 200 &&
        Array.isArray(response.data.data)
      ) {
        setSoldItems(response.data.data);
        console.log(response.data.data);
      } else {
        setSoldItems([]);
      }
    } catch (error) {
      console.error("Failed to fetch sold items:", error);
    }
  };

  // calculations of all bills total item stock and total sold stock
  const calculateInventory = (totalStockQuantitiesOfItem, soldItems) => {
    const inventory = totalStockQuantitiesOfItem.map((item) => {
      const soldItem = soldItems.find(
        (sold) => sold.itemName === item.itemName
      ) || { soldQuantity: 0 }; // Set default soldQuantity to 0
      const soldQuantity = soldItem.soldCount || 0;
      const remainingStock =
        Number(item.item_stockQuantity) - (Number(soldItem.soldCount) ||
          0);
      const purchasedCost =
        (Number(item.item_stockQuantity) || 0) * (Number(item.item_cost) || 0);
      const totalSellingCost =
        Number(item.item_stockQuantity || 0) *
        (Number(item.item_sellingCost) || 0);
      const remainingStockCost =
        (Number(item.item_stockQuantity) - (Number(soldItem.soldCount) || 0)) * (item.item_cost)
      const revenueFromSale =
        Number(soldItem.soldCount) * Number(item.item_sellingCost) ||
        0;
      const itemCost = Number(Number(item.item_cost));
      const itemSellingCost = Number(Number(item.item_sellingCost));

      return {
        itemId: item.itemId,
        itemName: item.itemName,
        totalStockQuantity: item.item_stockQuantity,
        soldQuantity,
        remainingStock,
        purchasedCost,
        totalSellingCost,
        remainingStockCost,
        revenueFromSale,
        itemCost,
        itemSellingCost,
      };
    });
    setLoading(false);
    console.log("Calculated Inventory:", inventory);
    return inventory;
  };

  //calculations for stock filters to know in each bill
  const calculateInventoryStocks = (itemsByUser, soldItems) => {

    const inventory = itemsByUser.map((item) => {
      // Find the matching sold item, if any
      const soldItem = soldItems.find(
        (sold) => sold.itemName === item.itemName && sold.billId === item.billId
      );

      // Extract sold quantity or default to 0 if no match
      const soldQuantity = soldItem?.sold_stockQuantity || 0;

      // Calculate remaining stock
      const remainingStock =
        Number(item.item_stockQuantity) - Number(soldQuantity);

      // Return stock details
      return {
        itemId: item.itemId,
        itemName: item.itemName,
        billId: item.billId,
        totalStockQuantity: item.item_stockQuantity,
        soldQuantity,
        remainingStock,
      };
    });

    // Filter out items with remainingStock equal to 0
    const filteredInventory = inventory.filter(item => item.remainingStock > 0);

    console.log("Filtered Inventory:", filteredInventory);
    return filteredInventory;
  };

  // calculations to get total aggregate  sold stack by item name for all bills
  const fetchSoldItemsByUser = async () => {
    if (!user || !user.orgId) return;

    try {
      const response = await fetchSoldItemById(user.orgId);

      if (
        response &&
        response.status === 200 &&
        Array.isArray(response.data.data)
      ) {

        setSoldItems(response.data.data);
        // Aggregate data
        const soldItemsData = response.data.data;
        const aggregatedData = soldItemsData.reduce((acc, item) => {
          const existingItem = acc.find((i) => i.itemName === item.itemName);

          if (existingItem) {
            // If itemName already exists, add to its sold count
            existingItem.soldCount += item.sold_stockQuantity;
          } else {
            // Add new item to the list with initial sold count
            acc.push({
              itemName: item.itemName,
              soldCount: item.sold_stockQuantity,
              quantity_ml: item.quantity_ml,
            });
          }

          return acc;
        }, []);

        setAggregateSoldStock(aggregatedData);
        console.log("Aggregated sold items by item name", aggregatedData);
      } else {
        setSoldItems([]);
      }
    } catch (error) {
      console.error("Failed to fetch sold items:", error);
    }
  };

  // calculations to get total aggregate stock items by item name for all bills
  function getTotalStockQuantityByItemName(data) {
    const stockQuantities = {};

    // Iterate from the last index to the first
    for (let i = data.length - 1; i >= 0; i--) {
      const item = data[i];
      const trimmedItemName = item.itemName;

      // If the item hasn't been added to stockQuantities, initialize it with all fields
      if (!stockQuantities[trimmedItemName]) {
        stockQuantities[trimmedItemName] = {
          ...item,
          itemName: trimmedItemName,
          item_stockQuantity: 0, // Reset stock quantity to start accumulation
        };
      }

      // Accumulate the stock quantity
      stockQuantities[trimmedItemName].item_stockQuantity += item.item_stockQuantity;
    }

    // Convert the stockQuantities object to an array of objects for compatibility
    const stockQuantitiesArray = Object.values(stockQuantities);

    console.log("Final aggregated stock quantities:", stockQuantitiesArray);
    setTotalStockQuanititiesOfItem(stockQuantitiesArray);
  }

  useEffect(() => {

    fetchBills(user.orgId);
    fetchItemsByUser();
    fetchSoldItemsByUser();


  }, []);

  // Run getTotalStockQuantityByItemName when itemsByUser is updated
  useEffect(() => {
    if (itemsByUser.length > 0) {
      getTotalStockQuantityByItemName(itemsByUser);
    }
  }, [itemsByUser]);

  useEffect(() => {
    if (totalStockQuantitiesOfItem.length > 0 && soldItems.length >= 0) {
      const finalInventoryData = calculateInventory(
        totalStockQuantitiesOfItem,
        aggregateSoldStock
      );
      const sortedData = finalInventoryData.sort((a, b) => a.itemId - b.itemId);
      setInventoryData(sortedData);


      console.log("final Inventory Data", finalInventoryData);
    }
    if (itemsByUser.length > 0 && soldItems.length >= 0) {
      const finalDataOfEachBill = calculateInventoryStocks(
        itemsByUser,
        soldItems
      );
      setStockInventoryData(finalDataOfEachBill);
      console.log("final Inventory Data of each bill", finalDataOfEachBill);
    }
  }, [totalStockQuantitiesOfItem, itemsByUser, soldItems]);



  // Helper function to format numbers with commas and currency symbol (₹)
  const formatCurrency = (value) =>
    `₹ ${new Intl.NumberFormat("en-IN").format(value)}`;

  const mergedData = items.map((item) => {
    // Find the sold item that matches the current item based on itemId
    const soldItem = soldItems.find(
      (sold) =>
        sold.itemName === item.itemName &&
        sold.quantity_ml === item.item_quantity
    ) || {
      sold_stockQuantity: 0,
      sold_cost: item.item_cost,
    };

    return {
      itemId: item.itemId,
      brand: item.itemName,
      totalQuantity: item.item_stockQuantity,
      soldQuantity: soldItem.sold_stockQuantity || 0,
      totalSoldPrice:
        (soldItem.sold_stockQuantity || 0) * (soldItem.sold_cost || 0),
      remainingQuantity:
        item.item_stockQuantity - (soldItem.sold_stockQuantity || 0),
      totalItemsPrice: item.item_stockQuantity * (item.item_cost || 0),
      totalSellingPrice: item.item_stockQuantity * (item.item_sellingCost || 0),
      remainingItemsPrice:
        item.item_stockQuantity * (item.item_sellingCost || 0) -
        (soldItem.sold_stockQuantity || 0) * (soldItem.sold_cost || 0),
      singlePrice: item.item_cost || 0,
      sellingPrice: item.item_sellingCost || 0,
    };
  });


  const filteredData = mergedData.filter((item) =>
    Object.values(item).some((value) =>
      value.toString().toLowerCase().includes(searchTerm.toLowerCase())
    )
  );

  // Total calculations for each column
  const totalQuantity = filteredData.reduce(
    (acc, item) => acc + item.totalQuantity,
    0
  );
  const totalSoldQuantity = filteredData.reduce(
    (acc, item) => acc + item.soldQuantity,
    0
  );
  const totalRemainingQuantity = filteredData.reduce(
    (acc, item) => acc + item.remainingQuantity,
    0
  );
  const totalPurchasedCost = filteredData.reduce(
    (acc, item) => acc + item.totalItemsPrice,
    0
  );
  const totalRevenue = filteredData.reduce(
    (acc, item) => acc + item.totalSellingPrice,
    0
  );
  const totalSalesRevenue = filteredData.reduce(
    (acc, item) => acc + item.totalSoldPrice,
    0
  );
  const totalRemainingValue = filteredData.reduce(
    (acc, item) => acc + item.totalItemsPrice,
    0
  );

  // Calculate each fee individually
  const issuePrice = totalPurchasedCost;
  const tcs = selectedBill.tcs;
  console.log(tcs);

  // Calculate the total amount
  const totalAmount = issuePrice + tcs;

  const icdcValue = issuePrice;

  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value.toLowerCase());
  };

  const filteredAggrigatedData = inventoryData.filter((item) =>
    item.itemName?.toString().toLowerCase().includes(searchTermAggrigate.toLowerCase())
  );
  
  const totalRemainingStock = filteredAggrigatedData.reduce((total, item) => {
    return total + item.remainingStockCost;
  }, 0);

  const totalSaleAmount = filteredAggrigatedData.reduce((total,item) =>{
    return total + item.revenueFromSale;

  },0 );

  
  const totalRemainingStockValue = Math.trunc(totalRemainingStock);
  const totalSaleStockValue = Math.trunc(totalSaleAmount);
  const handleSearch = (event) => {
    setSearchTermAggrigate(event.target.value);


  };
  const downloadPDF = () => {
    const doc = new jsPDF({
      orientation: "portrait",
      unit: "mm",
      format: [210, 300], // Custom height of 500mm
    });
    console.log(filteredData);
    if (billId) {
      // Column headers for the main table
      const tableColumns = [
        "item Code",
        "Item Name",
        "Stock Quantity",
        "Sold Quantity",
        "Remaining Quantity",
        "Issue Price/Item",
        "MRP",
        "Purchased Cost",
        "Revenue Cost",
        "Revenue From Sales",
        "Remaining Stock Value",
      ];

      // Rows for main table using filtered data
      const tableRows = filteredData.map((item) => [
        item.itemId,
        item.brand,
        item.totalQuantity,
        item.soldQuantity,
        item.remainingQuantity,
        item.singlePrice,
        item.sellingPrice,
        item.totalItemsPrice,
        item.totalSellingPrice,
        item.totalSoldPrice,
        item.remainingItemsPrice,
      ]);

      // PDF metadata
      doc.setFontSize(12);
      const headerY = 10;
      doc.text(`Shop Name: ${user.userName}`, 10, headerY);
      doc.text(`Org ID: ${user.orgId}`, 10, headerY + 6);
      doc.text(
        `Report Generated: ${new Date().toLocaleString('en-IN')}`,
        10,
        headerY + 12
      );

      // Generate main table
      doc.autoTable({
        startY: headerY + 18,
        head: [tableColumns],
        body: tableRows,
        styles: { fontSize: 8 },
        headStyles: { fillColor: [12, 13, 123] },
        theme: "grid",
        margin: { top: 10 },
      });

      // Pricing Breakdown Table
      const pricingStartY = doc.lastAutoTable.finalY + 10;
      const pricingData = [
        ["ICDC Value", icdcValue],
        ["Tax Collected At Source (TCS)", tcs],
        ["Total Amount", totalAmount],
      ];

      doc.text("Pricing Breakdown", 10, pricingStartY);
      doc.autoTable({
        startY: pricingStartY + 5,
        head: [["Description", "Amount"]],
        body: pricingData,
        styles: { fontSize: 10 },
        headStyles: { fillColor: [12, 13, 123] },
        theme: "grid",
        margin: { top: 10 },
      });
    } else {
      const tableColumns = [
        "S.NO",
        "Item Code",
        "Item Name",
        "Stock Quantity",
        "Sold Quantity",
        "Remaining Quantity",
        "MRP",
        "Revenue Cost",
        "Revenue From Sales",
        "Remaining Stock Value",
      ];

      // Rows for main table using filtered data
      let serialNumber = 1;
      const tableRows = inventoryData.map((item) => [
        serialNumber++,
        item.itemId,
        item.itemName,
        item.totalStockQuantity,
        item.soldQuantity,
        item.remainingStock,
        item.itemSellingCost,
        item.totalSellingCost,
        item.revenueFromSale,
        item.remainingStockCost,
      ]);

      // PDF metadata
      doc.setFontSize(12);
      const headerY = 10;
      doc.text(`Shop Name: ${user.userName}`, 10, headerY);
      doc.text(`Org ID: ${user.orgId}`, 10, headerY + 6);
      doc.text(
        `Report Generated: ${new Date().toLocaleString('en-IN')}`,
        10,
        headerY + 12
      );

      // Generate main table
      doc.autoTable({
        startY: headerY + 18,
        head: [tableColumns],
        body: tableRows,
        styles: { fontSize: 8 },
        headStyles: { fillColor: [12, 13, 123] },
        theme: "grid",
        margin: { top: 10 },
      });
    }

    const date = new Date();
    const formattedDate = `${date.getFullYear()}-${(date.getMonth() + 1)
      .toString()
      .padStart(2, "0")}-${date.getDate().toString().padStart(2, "0")}_${date
        .getHours()
        .toString()
        .padStart(2, "0")}-${date.getMinutes().toString().padStart(2, "0")}-${date
          .getSeconds()
          .toString()
          .padStart(2, "0")}`;
    let fileName;
    if (billId) {
      fileName = ` ${selectedBill.billName}_${formattedDate}.pdf`;
    } else {
      fileName = `Over All Reports_${formattedDate}.pdf`;
    }

    doc.save(fileName);
  };


  const downloadSalesPaper = (event) => {
   const storeId = event.target.id;
    const doc = new jsPDF({
      orientation: "portrait",
      unit: "mm",
      format: [210, 300], // Custom height
    });

    const tableColumns = [
      "S.No.",
      "Item Name",
      "Item Code",
      "ML",
      "Openings",
      "Closings",
      "Sales",
      "MRP",
      "Total Amount",

    ];

    const categoryOrder = [
      "Whisky",
      "Brandy",
      "Rum",
      "Vodka",
      "Wine",
      "Gin",
      "Breezer",
      "Beer",
    ];

    // Function to extract volume (e.g., "750ml" -> 750)
    const extractVolume = (itemName) => {
      const match = itemName.match(/(\d+)ml/);
      return match ? parseInt(match[1], 10) : null; // Return null if no match
    };

    // Clean up the item name by removing the volume
    // Clean up the item name by removing the volume and itemId (at the end)
    const cleanItemName = (itemName) => {
      return itemName
        .replace(/\s*\(\d+ml\)/i, '') // Removes (750ml) or any (xxxml) format
        .replace(/\s*\d+$/, '') // Removes trailing numbers (itemId)
        .trim();
    };


    // Sort inventory data by category order, then by item volume in descending order
    const sortedInventoryData = inventoryData
      .map((item) => ({
        ...item,
        ml: extractVolume(item.itemName), // Extract volume
        cleanedName: cleanItemName(item.itemName), // Remove volume from name


      }))
      .sort((a, b) => {
        // Sort by category
        const aCategoryIndex = categoryOrder.findIndex((category) =>
          a.itemName.includes(category)
        );
        const bCategoryIndex = categoryOrder.findIndex((category) =>
          b.itemName.includes(category)
        );

        const aIndex = aCategoryIndex === -1 ? Infinity : aCategoryIndex;
        const bIndex = bCategoryIndex === -1 ? Infinity : bCategoryIndex;

        if (aIndex !== bIndex) return aIndex - bIndex;

        // Sort by volume (descending)
        return (b.ml || 0) - (a.ml || 0);
      });
    console.log(sortedInventoryData);


    // Group by itemId and prepare rows
    const tableRows = [];
    categoryOrder.forEach((category) => {
      const categoryItems = sortedInventoryData.filter((item) =>
        item.itemName.includes(category)
      );

      if (categoryItems.length > 0) {
        // Add category header
        tableRows.push([
          {
            content: category,
            colSpan: tableColumns.length,
            styles: { halign: "center", fontStyle: "bold" },
          },
        ]);

        const groupedItems = categoryItems.reduce((acc, item) => {
          if (!acc[item.itemId]) acc[item.itemId] = [];
          acc[item.itemId].push(item);
          return acc;
        }, {});

        let serialNumber = 1; // Reset serial number for each category
        Object.values(groupedItems).forEach((group) => {
          group.forEach((item, index) => {
            tableRows.push([
              serialNumber++, // Serial Number
              item.cleanedName, // Use the cleaned item name
              item.itemId,
              item.ml || "", // Display the volume (ML)
              storeId ? "" :item.remainingStock,
              "",
              "",
              item.itemSellingCost,
              "",

            ]);
          });
        });
      }
    });

    doc.setFontSize(12);
    const headerY = 10;

    // Add metadata
    doc.text(`Shop Name: ${user.userName}`, 10, headerY);
    doc.text(`Org ID: ${user.orgId}`, 10, headerY + 6);
    doc.text(
      `Report Generated: ${new Date().toLocaleString("en-IN")}`,
      10,
      headerY + 12
    );

    // Add table
    doc.autoTable({
      startY: headerY + 18,
      head: [tableColumns],
      body: tableRows,
      styles: { fontSize: 8 },
      headStyles: { fillColor: [12, 13, 123] },
      theme: "grid",
      margin: { top: 10 },
    });

    // Save PDF
    const date = new Date();
    const formattedDate = `${date.getFullYear()}-${(date.getMonth() + 1)
      .toString()
      .padStart(2, "0")}-${date.getDate().toString().padStart(2, "0")}_${date
        .getHours()
        .toString()
        .padStart(2, "0")}-${date.getMinutes().toString().padStart(2, "0")}-${date
          .getSeconds()
          .toString()
          .padStart(2, "0")}`;
    const fileName = `Sales Paper_${formattedDate}.pdf`;
    doc.save(fileName);
  };


  return (
    <>
    <style>
        {`
          @media (min-width: 1200px) {
            .css-5c1adp-MuiContainer-root {
              max-width: 100vw !important;
            }
          }
        `}
      </style>
    <Container >
      <Box >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: "10px",
          }}
        >
          <Typography
            variant={isMobile ? "h6" : "h5"}
            gutterBottom
            sx={{ color: "#024CAA" }}
          >
            Beverage Items Reports
          </Typography>
          {billId !== "" && (
            <Button
              variant="contained"
              // color="White"
              onClick={goAgrigateData}
              sx={{ marginBottom: "10px", background: "#074799", color: "white" }}
            >
              <FastRewindRoundedIcon /> Back
            </Button>
          )}
        </Box>

        <Box
          display="flex"
          flexDirection={isMobile ? "column" : "row"}
          justifyContent="space-between"
          alignItems="center"
          width="100%"
        >
          <Box
            width={isMobile ? "100%" : "32%"}
            mb={isMobile ? 1 : 0}
            sx={{
              "& .MuiOutlinedInput-root": {
                "& fieldset": { borderColor: "gray" },
                "&:hover fieldset": { borderColor: "gray" },
                "&.Mui-focused fieldset": { borderColor: "gray" },
                marginBottom: "10px",
                padding: "0px",
              },
            }}
          >

            <Grid item xs={12}
              sx={{
                "& .MuiOutlinedInput-root": {
                  "& fieldset": { borderColor: "gray" },
                  "&:hover fieldset": { borderColor: "gray" },
                  "&.Mui-focused fieldset": { borderColor: "gray" },
                  marginBottom: "10px",

                },
              }}>
              <Autocomplete
                options={bills}
                getOptionLabel={(bill) => bill.billName}
                value={billId ? bills.find((bill) => bill._id === billId) : null}
                onChange={(e, selectedBill) => {
                  if (selectedBill) {
                    setBillId(selectedBill._id);
                    fetchItemsByBillId(selectedBill._id);
                    fetchSoldItemsByBill(selectedBill._id);
                    setSelectedBill(selectedBill);
                    console.log(selectedBill);
                  }
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Search Bills"
                    placeholder="Select Bill"
                    fullWidth
                    size="small"
                    sx={{
                      "& .MuiInputBase-input": {
                        color: "#071952", // Changes the input text color
                      },
                      "& .MuiInputLabel-root": {
                        color: "#071952", // Changes the label text color
                      },
                      input: { color: "#071952", padding: "6px" },
                      "& .MuiOutlinedInput-root": {
                        "& fieldset": { borderColor: "#071952" },
                        "&:hover fieldset": { borderColor: "#071952" },
                        "&.Mui-focused fieldset": { borderColor: "#3572EF" },
                        marginBottom: "10px",



                      },
                    }}
                  />
                )}
              />
            </Grid>

          </Box>


          {billId ? (
            <Box width={isMobile ? "100%" : "32%"} mb={isMobile ? 1 : 0}>
              <TextField
                variant="outlined"
                fullWidth
                value={searchTerm}
                onChange={handleSearchChange}
                placeholder="Search by item name"
                sx={{
                  input: { color: "#071952", padding: "8px" },
                  "& .MuiOutlinedInput-root": {
                    "& fieldset": { borderColor: "#071952" },
                    "&:hover fieldset": { borderColor: "#071952" },
                    "&.Mui-focused fieldset": { borderColor: "#3572EF" },
                    marginBottom: "10px",
                    color: "#0B2F9F",

                  },
                  "& .MuiInputBase-input": {
                    color: "#050C9C", // Changes the input text color
                  },
                  "& .MuiInputLabel-root": {
                    color: "#071952", // Changes the label text color
                  },
                }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <SearchIcon style={{ color: "#071952" }} />
                    </InputAdornment>
                  ),
                }}
              />
            </Box>
          ) : (
            <Box
              width={isMobile ? "100%" : "32%"}
              mb={isMobile ? 1 : 0}
              sx={{
                "& .MuiOutlinedInput-root": {
                  "& fieldset": { borderColor: "gray" },
                  "&:hover fieldset": { borderColor: "gray" },
                  "&.Mui-focused fieldset": { borderColor: "gray" },
                  marginBottom: "10px",
                  padding: "0px",
                },
              }}>
              <TextField
                variant="outlined"
                fullWidth
                value={searchTermAggrigate}
                onChange={handleSearch}
                placeholder="Search by item name"
                sx={{
                  input: { color: "#071952", padding: "8px" },
                  "& .MuiOutlinedInput-root": {
                    "& fieldset": { borderColor: "#071952" },
                    "&:hover fieldset": { borderColor: "#071952" },
                    "&.Mui-focused fieldset": { borderColor: "#3572EF" },

                  },
                  "& .MuiInputBase-input": {
                    color: "#050C9C", // Changes the input text color
                  },
                  "& .MuiInputLabel-root": {
                    color: "#071952", // Changes the label text color
                  },

                }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <SearchIcon style={{ color: "#071952", marginRight: "10px" }} />
                    </InputAdornment>
                  ),
                }}
              />
            </Box>
          )}



          {billId ? <Button
            variant="contained"
            color="secondary"
            onClick={downloadPDF}
            sx={{ marginBottom: "10px", background: "#3F52E3", textTransform: "none", borderRadius: "6px ", padding: "8px 15px" }}
          >
            <GetAppRoundedIcon />Bill Reports
          </Button> : <Button
            variant="contained"
            color="secondary"
            onClick={downloadPDF}
            sx={{ marginBottom: "10px", background: "#3F52E3", textTransform: "none", borderRadius: "6px", padding: "8px 15px" }}
          >
            <GetAppRoundedIcon />Over All Reports
          </Button>}
          {!billId && <Button
            variant="contained"
            color="secondary"
            onClick={downloadSalesPaper}
            sx={{ marginBottom: "10px", textTransform: "none", borderRadius: "6px", padding: "8px 15px", background: "#180161" }}
          >
            <GetAppRoundedIcon /> Sales Paper
          </Button>}
          {/* {!billId && <Button
            variant="contained"
            color="secondary" 
            id="wop"
            onClick={downloadSalesPaper}
            sx={{ marginBottom: "10px", textTransform: "none", borderRadius: "6px", padding: "8px 15px", background: "#180161" }}
          >
            <GetAppRoundedIcon /> Sales Paper W_O_P
          </Button>} */}

        </Box>

        <TableContainer
          component={Paper}
          sx={{
            maxHeight: isExtraLargeDevice
              ? 490 // Height for extra-large devices
              : isLargeDevice
                ? 420 // Height for large devices
                : 370, // Default height for other devices
            maxWidth: isExtraLargeDevice ? "100vw" : "none", // Max-width cap for XL
            margin: isExtraLargeDevice ? "0 auto" : "inherit", // Center for XL
            overflowY: "auto",
            display: "flex",
            flexDirection: "column",
            "&::-webkit-scrollbar": {
              width: "6px",
              height: "6px",
            },
            "&::-webkit-scrollbar-track": { backgroundColor: "#f1f1f1" },
            "&::-webkit-scrollbar-thumb": {
              backgroundColor: "#888",
              borderRadius: "6px",
            },
            "&::-webkit-scrollbar-thumb:hover": { backgroundColor: "#555" },
          }}
        >

          <div id="pdfContent">
            <Table stickyHeader sx={{ flex: 1 }}>
              <TableHead>
                <TableRow>
                  <TableCell
                    sx={{
                      textAlign: "center",
                      color: "white",
                      backgroundColor: "#133E87",
                      fontWeight: "600",
                      maxWidth: "200px",
                      padding: " 12px 5px",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                    }}
                  >
                    Item Code
                  </TableCell>
                  <TableCell
                    sx={{
                      textAlign: "center",
                      color: "white",
                      backgroundColor: "#133E87",
                      fontWeight: "600",
                      minWidth: "200px",
                      padding: " 12px 5px",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                    }}
                  >
                    Item Name
                  </TableCell>
                  <TableCell
                    sx={{
                      textAlign: "center",
                      color: "white",
                      backgroundColor: "#133E87",
                      fontWeight: "600",
                      fontSize: "12px",
                      maxWidth: "200px",
                      padding: "12px 5px",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                    }}
                  >
                    Stock Quantity
                  </TableCell>
                  {billId ? ("") : (<TableCell
                    sx={{
                      textAlign: "center",
                      color: "white",
                      backgroundColor: "#133E87",
                      fontWeight: "600",
                      fontSize: "12px",
                      maxWidth: "200px",
                      padding: "12px 5px",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                    }}
                  >
                    Sales Quantity
                  </TableCell>)}

                  {billId ? ("") : (<TableCell
                    sx={{
                      textAlign: "center",
                      color: "white",
                      backgroundColor: "#133E87",
                      fontWeight: "600",
                      fontSize: "12px",
                      maxWidth: "200px",
                      padding: "12px 5px",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                    }}
                  >
                    Remaining Quantity
                  </TableCell>)}


                  {billId ? (
                    <TableCell
                      sx={{
                        textAlign: "center",
                        color: "white",
                        backgroundColor: "#133E87",
                        fontWeight: "600",
                        fontSize: "12px",
                        maxWidth: "200px",
                        padding: "12px 5px",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                      }}
                    >
                      Issue Price
                    </TableCell>
                  ) : (
                    ""
                  )}
                  <TableCell
                    sx={{
                      textAlign: "center",
                      color: "white",
                      backgroundColor: "#133E87",
                      fontWeight: "600",
                      fontSize: "12px",
                      maxWidth: "200px",
                      padding: "12px 5px",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                    }}
                  >
                    MRP
                  </TableCell>
                  {billId ? (
                    <TableCell
                      sx={{
                        textAlign: "center",
                        color: "white",
                        backgroundColor: "#133E87",
                        fontWeight: "600",
                        fontSize: "12px",
                        maxWidth: "200px",
                        padding: "12px 5px",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                      }}
                    >
                      Purchased Price
                    </TableCell>
                  ) : (
                    ""
                  )}

                  <TableCell
                    sx={{
                      textAlign: "center",
                      color: "white",
                      backgroundColor: "#133E87",
                      fontWeight: "600",
                      fontSize: "12px",
                      maxWidth: "200px",
                      padding: "12px 5px",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                    }}
                  >
                    Gross MRP Amount
                  </TableCell>
                  {/* {billId ? ("") : (<TableCell
                    sx={{
                      textAlign: "center",
                      color: "white",
                      backgroundColor: "#133E87",
                      fontWeight: "600",
                      fontSize: "12px",
                      maxWidth: "200px",
                      padding: "12px 5px",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                    }}
                  >
                    Sales Amount
                  </TableCell>)} */}
                  {billId ? ("") : (<TableCell
                    sx={{
                      textAlign: "center",
                      color: "white",
                      backgroundColor: "#133E87",
                      fontWeight: "600",
                      fontSize: "12px",
                      maxWidth: "200px",
                      padding: "12px 5px",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                    }}
                  >
                    Remaining Stock Amount
                  </TableCell>)}

                </TableRow>
              </TableHead>
              <TableBody>
                {billId
                  ? filteredData.map((item, index) => (
                    <TableRow key={index}>
                      <TableCell
                        sx={{
                          textAlign: "center",
                          minWidth: "200px",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                        }}
                      >
                        {item.itemId}
                      </TableCell>
                      <TableCell
                        sx={{
                          textAlign: "center",
                          minWidth: "200px",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                        }}
                      >
                        {item.brand}
                      </TableCell>
                      <TableCell
                        sx={{
                          textAlign: "center",
                          maxWidth: "200px",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                        }}
                      >
                        {item.totalQuantity}
                      </TableCell>

                      <TableCell
                        sx={{
                          textAlign: "center",
                          maxWidth: "200px",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                        }}
                      >
                        {formatCurrency(item.singlePrice)}
                      </TableCell>
                      <TableCell
                        sx={{
                          textAlign: "center",
                          maxWidth: "200px",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                        }}
                      >
                        {formatCurrency(item.sellingPrice)}
                      </TableCell>
                      <TableCell
                        sx={{
                          textAlign: "center",
                          maxWidth: "200px",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                        }}
                      >
                        {formatCurrency(item.totalItemsPrice)}
                      </TableCell>
                      <TableCell
                        sx={{
                          textAlign: "center",
                          maxWidth: "200px",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                        }}
                      >
                        {formatCurrency(item.totalSellingPrice)}
                      </TableCell>


                    </TableRow>
                  ))
                  : loading ? (<TableRow>
                    <TableCell colSpan={9} align="center" sx={{ padding: 0, height: "60px" }}>
                      <Box
                        display="flex"
                        justifyContent="center"
                        alignItems="center"
                        height="100%"
                      >
                        <SpinnerLoading color="primary" />
                      </Box>
                    </TableCell>
                  </TableRow>
                  ) : inventoryData ? (filteredAggrigatedData.map((item, index) => (
                    <TableRow key={index}>
                      <TableCell
                        sx={{
                          textAlign: "center",
                          minWidth: "200px",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                        }}
                      >
                        {item.itemId}
                      </TableCell>
                      <TableCell
                        sx={{
                          textAlign: "center",
                          minWidth: "200px",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                        }}
                      >
                        {item.itemName}
                      </TableCell>
                      <TableCell
                        sx={{
                          textAlign: "center",
                          maxWidth: "200px",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                        }}
                      >
                        {item.totalStockQuantity}
                      </TableCell>
                      {billId ? ("") : (<TableCell
                        sx={{
                          textAlign: "center",
                          maxWidth: "200px",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                        }}
                      >
                        {item.soldQuantity}
                      </TableCell>)}
                      {billId ? ("") : (<TableCell
                        sx={{
                          textAlign: "center",
                          maxWidth: "200px",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                        }}
                      >
                        {item.remainingStock}
                      </TableCell>)}

                      {billId ? (
                        <TableCell
                          sx={{
                            textAlign: "center",
                            maxWidth: "200px",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                          }}
                        >
                          {formatCurrency(item.itemCost)}
                        </TableCell>
                      ) : (
                        ""
                      )}

                      <TableCell
                        sx={{
                          textAlign: "center",
                          maxWidth: "200px",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                        }}
                      >
                        {formatCurrency(item.itemSellingCost)}
                      </TableCell>
                      {billId ? (
                        <TableCell
                          sx={{
                            textAlign: "center",
                            maxWidth: "200px",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                          }}
                        >
                          {formatCurrency(item.purchasedCost)}
                        </TableCell>
                      ) : (
                        ""
                      )}
                      {billId ? ("") : (<TableCell
                        sx={{
                          textAlign: "center",
                          maxWidth: "200px",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                        }}
                      >
                        {formatCurrency(item.totalSellingCost)}
                      </TableCell>)}
                      {/* {billId ? ("") : (<TableCell
                        sx={{
                          textAlign: "center",
                          maxWidth: "200px",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                        }}
                      >
                        {formatCurrency(item.revenueFromSale)}
                      </TableCell>)} */}

                      <TableCell
                        sx={{
                          textAlign: "center",
                          maxWidth: "200px",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                        }}
                      >
                        {formatCurrency(item.remainingStockCost)}
                      </TableCell>
                    </TableRow>

                  ))) : (<TableRow>
                    <TableCell
                      colSpan={7}
                      align="center"
                      sx={{ color: "#133E87" }}
                    >
                      No item reports found.
                    </TableCell>
                  </TableRow>)}
                {billId ? (
                  <TableRow
                    sx={{
                      backgroundColor: "#1450A3",
                      fontWeight: "bold",
                    }}
                  >
                    <TableCell sx={{ textAlign: "center", color: "white" }}>
                      Total
                    </TableCell>
                    <TableCell
                      sx={{ textAlign: "center", color: "white" }}
                    ></TableCell>
                    <TableCell sx={{ textAlign: "center", color: "white" }}>
                      {totalQuantity}
                    </TableCell>
                    <TableCell
                      sx={{ textAlign: "center", color: "white" }}
                    ></TableCell>
                    <TableCell
                      sx={{ textAlign: "center", color: "white" }}
                    ></TableCell>
                    <TableCell sx={{ textAlign: "center", color: "white" }}>
                      {formatCurrency(totalPurchasedCost)}
                    </TableCell>
                    <TableCell sx={{ textAlign: "center", color: "white" }}>
                      {formatCurrency(totalRevenue)}
                    </TableCell>
                  </TableRow>
                ) : (
                  <TableRow
                    sx={{
                      backgroundColor: "#1450A3",
                      fontWeight: "bold",
                    }}
                  >
                    <TableCell sx={{ textAlign: "center", color: "white" }}>
                      {""}
                    </TableCell>
                    <TableCell
                      sx={{ textAlign: "center", color: "white" }}
                    ></TableCell>
                    <TableCell sx={{ textAlign: "center", color: "white" }}>
                      {""}
                    </TableCell>
                    <TableCell
                      sx={{ textAlign: "center", color: "white" }}
                    ></TableCell>
                    <TableCell
                      sx={{ textAlign: "center", color: "white" }}
                    ></TableCell>
                    
                   
                    <TableCell sx={{ textAlign: "center", color: "white" }}>
                      {""}
                    </TableCell>
                    
                    
                    {user.role === "owner" ? (<TableCell sx={{ textAlign: "center", color: "white" }}>
                      {""}
                    </TableCell>) : ("")}
                    {/* <TableCell sx={{ textAlign: "center", color: "#FEEC37", fontSize: "16px", fontWeight: "bold" }}>
                      {""}
                    </TableCell> */}
                    <TableCell sx={{ textAlign: "center", color: "#FEEC37", fontSize: "16px", fontWeight: "bold" }}>
                      Total :{`  ₹ ${totalRemainingStockValue}`}
                    </TableCell>

                  </TableRow>
                )}
              </TableBody>
            </Table>
          </div>

        </TableContainer>
        {billId ? (
          <Box
            sx={{
              display: "flex",
              justifyContent: "end",
            }}
          >
            <Box
              sx={{
                backgroundColor: "white",
                padding: 2,
                borderRadius: 2,
                boxShadow: "0px 8px 20px rgba(0, 0, 0, 0.5)",
                minWidth: "40%",
                marginTop: "20px",
                marginBottom:"100px"
              }}
            >
              <Typography variant="h6" gutterBottom>
                Pricing Breakdown
              </Typography>

              <Divider sx={{ marginY: 2, background: "#17153B" }} />
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  marginBottom: 1.5,
                }}
              >
                <Typography>ICDC Value</Typography>
                <Typography fontWeight="bold">
                  {isNaN(icdcValue)
                    ? "0.00"
                    : formatCurrency(icdcValue.toFixed(2))}
                </Typography>
              </Box>

              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  marginBottom: 1.5,
                }}
              >
                <Typography>Tax Collected At Source (TCS)</Typography>
                <Typography fontWeight="bold">
                  {isNaN(tcs) ? "0.00" : formatCurrency(tcs.toFixed(2))}
                </Typography>
              </Box>

              <Divider sx={{ marginY: 2, background: "#17153B" }} />

              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  marginTop: 2,
                }}
              >
                <Typography variant="subtitle1" fontWeight="bold">
                  Total Amount
                </Typography>
                <Typography variant="subtitle1" fontWeight="bold">
                  {isNaN(totalAmount)
                    ? "0.00"
                    : formatCurrency(totalAmount.toFixed(2))}
                </Typography>
              </Box>
            </Box>
          </Box>
        ) : (
          ""
        )}
      </Box>
    </Container>
    </>
  );
};

export default Reports;
